import { setGetAccessTokenSilently } from '@/api';
import { useAuth0 } from '@auth0/auth0-react';
import { useCallback, useLayoutEffect } from 'react';

export default function useAuthInject() {
	const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

	const getTokenFn = useCallback(async () => {
		try {
			return await getAccessTokenSilently();
		} catch (e) {
			if (e instanceof Error && e.message === 'Login required') {
				const returnTo = `${window.location.pathname}${window.location.search || ''}`;
				loginWithRedirect({ appState: { returnTo } });
				return null;
			} else {
				throw e;
			}
		}
	}, [getAccessTokenSilently, loginWithRedirect]);

	useLayoutEffect(() => {
		setGetAccessTokenSilently(getTokenFn);
	}, [getTokenFn]);
}
